import RequestState from 'Enums/RequestState'

export const INITIAL_STATE = {
  fetchOverviewRequestState: RequestState.UNINITIALIZED,
  overview: {},
  fetchAverageDurationRequestState: RequestState.UNINITIALIZED,
  averageDuration: {},
  fetchTransactionsStatisticsRequestState: RequestState.UNINITIALIZED,
  transactionsStatistics: {},
  fetchConnectorsStatusRequestState: RequestState.UNINITIALIZED,
  connectorsStatus: {},
  fetchPeakHourRequestState: RequestState.UNINITIALIZED,
  peakHour: {},
  fetchTopSitesRequestState: RequestState.UNINITIALIZED,
  topSites: { data: [] },
  fetchTokensStatisticsRequestState: RequestState.UNINITIALIZED,
  tokensStatistics: {},
  fetchRevenueTrendRequestState: RequestState.UNINITIALIZED,
  revenueTrend: {},
  fetchTokensActivityRequestState: RequestState.UNINITIALIZED,
  tokensActivity: {},
  fetchTopCitiesRequestState: RequestState.UNINITIALIZED,
  topCities: { data: [] },
}
